var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"inline-flex justify-center items-center mx-1"},[_vm._l((_vm.options.colors),function(color,idx_color){return [_c('span',{key:idx_color,staticClass:"q10__triangle",class:[color, 'triangle_direction_' + _vm.options.direction],style:({
                borderColor: ("transparent transparent transparent " + color),
            })})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }